module.exports = __webpack_public_path__ + "img/107.05bbdba4.gif";